import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { AITextGenerationLocalContextType } from '../../../../AITextGeneration'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FormModal, formValidationSchemaNoChanged } from '../../../../Form'
import {
  isFormCommentsFieldsEqual,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE,
  REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
  REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
  REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
  RequestEditUserCommentFields,
} from '../../../../Request'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import {
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT,
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT,
} from '../RequestProfileWidgetResponsibleManagers.constants'

import * as styles from './SendInviteField.module.css'

function SendInviteField({ requestId }) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, setValues, values } = useFormikContext()

  const { handleCloseModal, setModal } = useRequestProfileContext()

  const isComment =
    values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT]

  function handleSaveNoticeValues({ values: noticeValues }) {
    setValues({
      ...values,
      ...noticeValues,
      [REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT]: true,
    })

    handleCloseModal()
  }

  function handleOpenNoticeModal() {
    const initialValues =
      values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT] ||
      values[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE]
        ? values
        : REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE

    setModal(
      <FormModal
        Fields={RequestEditUserCommentFields}
        containerProps={{
          boxSize: REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
          qaName: REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
        }}
        formBodyProps={{
          withNotifications: true,
        }}
        formFieldsProps={{
          aiLocalContext: {
            object_id: String(requestId),
            type: AITextGenerationLocalContextType.ServiceRequestEmail,
          },
          commentFieldName:
            REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT,
          containerClassName: styles.noticeFields,
          id: requestId,
          textareaClassName: styles.noticeTextarea,
        }}
        formTitle='Modal.SendInvitationTitleKey'
        initialValues={initialValues}
        validationSchema={formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormCommentsFieldsEqual,
        })}
        onClose={handleCloseModal}
        onSubmit={handleSaveNoticeValues}
      />
    )
  }

  function handleToggleComment(checked) {
    if (checked) {
      handleOpenNoticeModal()
    } else {
      setFieldValue(
        REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT,
        false
      )
    }
  }

  const disabledCheckbox =
    values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES].length ===
    0

  return (
    <Checkbox
      showTooltip
      buttonProps={{
        text: t('RequestProfile.ResponsibleManagersWidgetViewTextBtnKey'),
        onClick: handleOpenNoticeModal,
      }}
      checked={isComment}
      disabled={disabledCheckbox || isSubmitting}
      label={t('Modal.SendNotificationLabelKey')}
      labelClassName={styles.checkboxLabel}
      labelTitleClassName={styles.checkboxLabelTitle}
      name={REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT}
      qaName={REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT}
      size={CHECKBOX_SIZE.small}
      tooltip={
        disabledCheckbox
          ? t(
              'Modal.SendNotificationEmptyAssigneesTypeDisabledCheckboxTooltipKey'
            )
          : null
      }
      type={CHECKBOX_TYPE.action}
      onChange={handleToggleComment}
    />
  )
}

export default SendInviteField
